var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"17","height":"17","rx":"4.5","stroke":"#3C6065"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }